/** Máscara BR para telefone celular/fixo (até 11 dígitos). */
export function formatPhone(value: string): string {
  let raw = value.replace(/\D/g, '')
  if (raw.length > 11) raw = raw.slice(0, 11)

  if (raw.length > 10) {
    return raw.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1) $2-$3')
  }
  if (raw.length > 5) {
    return raw.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, '($1) $2-$3')
  }
  if (raw.length > 2) {
    return raw.replace(/^(\d\d)(\d{0,5}).*/, '($1) $2')
  }
  if (raw.length > 0) {
    return raw.replace(/^(\d*)/, '($1')
  }
  return raw
}

export function normalizePhoneDigits(value: string): string {
  return value.replace(/\D/g, '')
}
